import { useEffect } from 'react'
import { selectAppLoginStatus } from '../../features/auth/selectors'
import { useTeloRouter } from '../../routing/teloRouter'
import { useTeloSelector } from '../../store'
import { deleteIntersessionInactivityModalShown } from '../../libs/intersession'

export const useLogoutNavigation = () => {
	const { navigate } = useTeloRouter()
	const loginStatus = useTeloSelector(selectAppLoginStatus)
	useEffect(() => {
		if (loginStatus === 'logging out') {
			navigate('/logout')
			deleteIntersessionInactivityModalShown()
		}
	}, [loginStatus, navigate])
}
